// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "e40f0d7ff3c8285e84df" + ".chunk.js";
};